import { Component, ElementRef, OnInit,ViewChild,ViewEncapsulation } from '@angular/core';
import { ConfirmationService, ConfirmEventType, LazyLoadEvent, MenuItem, MessageService, PrimeNGConfig } from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';
import { SelectItem, FilterService, FilterMatchMode } from "primeng/api";
import { Table } from 'primeng/table';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractControl, FormBuilder, FormControl, ValidatorFn, Validators } from '@angular/forms';
import { SharedService } from 'src/app/shared/services';
import {UserApprovalService} from'../../../services/userapproval.service'
import { IGlobalSearchParam, ISearchGlobalFilter } from 'src/app/shared/models/Global-Search.model';
import { IUserDetails } from 'src/app/admin/models/user.model';
import {CompanyApprovalService} from'../../../services/company-approval-service';
import { Router, ActivatedRoute, NavigationStart} from '@angular/router';
import { JwtService } from 'src/app/auth/services';
import { RegisterService } from 'src/app/auth/services/register.service';
import { CompanyService } from 'src/app/users/services';
import { ICompanyNotes } from 'src/app/users/models/company.model';
import * as fs from 'file-saver';
import { ILookupCategory } from 'src/app/shared/models/lookup.model';
import { LookupCategory,Payment_Terms } from 'src/app/shared/enums/EnumsVMS';
import Quill from 'quill';
import ImageUploader from 'quill-image-uploader';
import { VMSConstants } from 'src/app/shared/constants/vms-constants';
Quill.register("modules/imageUploader", ImageUploader);

@Component({
  selector: 'app-company-approval-search',
  templateUrl: './company-approval-search.component.html',
  styleUrls: ['./company-approval-search.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class CompanyApprovalSearchComponent implements OnInit {
  sortField:string = 'createdOn';
  sortOrder:string = 'desc';
  oldSortField:string = 'createdOn';
  oldSortOrder:string = 'desc';
  appliedFilters:{field:string,matchMode:string,value:string}[]=[];
  pageNo: number =1;
  pageSize: number =10;
  oldPageNo: number =1;
  oldPageSize: number =10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] =[];
  startSearch: boolean = false;
  companyApprovalList;
  gridSpinner = 'gridSpinner1';
  isSearchLoading: boolean = false;
  loading: boolean = false;
  companyApprovalSearchParam:IGlobalSearchParam;
  searchGlobalFilter: ISearchGlobalFilter[]=[];
  showAddRuleButtonCO:boolean = false;
  showAddRuleButtonMO:boolean = false;
  showAddRuleButtonSO:boolean = false;
  companyApprovalSearchSpinner = 'userApprovalSearchSpinner';
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  showFilters:boolean;
  showSorting:boolean;
  gridGlobalFilter: SelectItem[];
  showTopFilters: boolean;
  displayModal:boolean = false;
  displayNotesHistoryModal:boolean =false;
  displayNotesDescriptionModal:boolean = false; 
  //notes;
  notesList;
  companyId:number;
  userActionDescription:string;
  selectedGridMenuItem:any = null;
  items: MenuItem[];
  itemsNew: MenuItem[];
  showToggle:boolean;
  isshowpaginator:boolean=true;
  categoryName;
  paymentTermsList:ILookupCategory;
  paymentTermsId: any;
  companyApprovalStatus: ILookupCategory;
  approvalStatusId: any;
  public selectedApprovalStatusId:Array<any> = [];
  selectedApprovalStatus:any;
  public selectedPaymentTermsId:Array<any> = [];
  matchModeOptionsForDropdown: SelectItem[];
  arrCompanyApprovalStatus:any;
  //selectedPaymentTermsId = new FormControl([]);
  tempselectedPaymentTermsId: any = [];
   allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'companyName', header: 'Company Name' },
    { value: 'companyProfileId', header: 'Company Id' },
    { value: 'companyType', header: 'Company Type' },
    { value: 'adminName', header: 'Admin Name' },
    { value: 'adminEmail', header: 'Admin Email' },
    { value: 'paymentTerms', header: 'Payment Terms' },
    { value: 'createdOn', header: 'Created On' },
    { value: 'modifiedOn', header: 'Modified On' },
    { value: 'submittedOn', header: 'Submitted On' },
    { value: 'approvalStatus', header: 'Approval Status' },
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'companyName', header: 'Company Name' },
    { value: 'companyProfileId', header: 'Company Id' },
    { value: 'companyType', header: 'Company Type' },
    { value: 'adminName', header: 'Admin Name' },
    { value: 'adminEmail', header: 'Admin Email' },
    { value: 'paymentTerms', header: 'Payment Terms' },
    { value: 'createdOn', header: 'Created On' },
    { value: 'modifiedOn', header: 'Modified On' },
    { value: 'submittedOn', header: 'Submitted On' },
    { value: 'approvalStatus', header: 'Approval Status' },
  ]
  editorMaxlenthError =  false;
  notesFormControl = new FormControl("",[Validators.required, this.editorMaxLength(5000)]);
  isUploadCompleted = false;
  editorModules = {
    toolbar: [   
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }], 
        [{ 'font': [] }],   
        ['bold', 'italic', 'underline', 'strike'], 
        [{ 'color': [] }, { 'background': [] }], 
        [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        [{ 'align': [] }],
        ['link', 'image']
    ], imageUploader: {
      upload: (file) => {
        return new Promise((resolve, reject) => {
          if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {
            if (file.size < 2097152) {
              this.isUploadCompleted = true;
              this.sharedService.uploadEditorImage(file).then(res => {
                this.isUploadCompleted = false;
                resolve(VMSConstants.editiorImageBaseUrl + res.substring(1));
              }).catch(err => {
                reject(err);
              })
            } else {
              reject('Size too large');
            }
          }
          else {
            reject('Unsupported type');
          }
        });
      },
    },
  };


  //paymentTerms: ILookupCategory;
  selectedPaymentTerms:any;
  arrPaymentTerms: any;
  // public selectedPaymentTermsId:Array<any> = [];
  // arrPaymentTerms:any;
  // paymentTermsId: any;

  @ViewChild('dt2', { static: true }) table: any;

  constructor( 
    private companyApprovalService:CompanyApprovalService,
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private primengConfig: PrimeNGConfig,
    private _fb: FormBuilder,
    public sharedService:SharedService,
    private jwtService:JwtService,
    private registerService:RegisterService,
    private companyService:CompanyService,
    private _router: Router,) { this.showFilters = false;
      this.showSorting = false;
      this.spinner.show();
      setTimeout(() => {
          this.spinner.hide();
      }, 1000);
     // setInterval(() =>  this.checkSessionTimeout(), 60000);
    //  _router.events.forEach((event) => {
    //   if (event instanceof NavigationStart) {
    //      if ((event['url'] == '/login') || (event['url'] == '/')|| (event['url'] == '/register')|| (event['url'] == '/register-profile')|| (event['url'] == '/forgot-password') || (event['url'] == '/users/new-user-change-password')) {
    //      // this.show = false;
    //      }
    //      else {
    //       var isTokenAvailable = this.sharedService.isTokenAvailable();
         
    //       if(isTokenAvailable){
    //       setInterval(() =>  this.checkSessionTimeout(), 60000);
    //       }
        
    //      }
    //     }
    // });
      this.items = [
       
        {
         label:'Approve',
         icon:'pi pi-fw pi-check',
         command: e => this.approveCompany(this.selectedGridMenuItem.adminUserProfileId,this.selectedGridMenuItem.companyId)
        },
        {
          label:'Notes History',
          icon:'pi pi-comments',
          command: e => this.notesHistory(e)
         },
        {
          label:'Need Information',
          icon:'pi pi-fw pi-plus',
          command: e => this.needInformation(e)
         },
         {
          label:'In Review',
          icon:'pi pi-pencil',
          command: e => this.inReview(e)
         },
         {
          label:'Reject',
          icon:'pi pi-fw pi-times',
          command: e => this.rejectCompany(this.selectedGridMenuItem.companyId)
         },
       
     ];
     this.itemsNew = [
       
      
      {
        label:'Notes History',
        icon:'pi pi-comments',
        command: e => this.notesHistory(e)
       },
      
     
   ];
    }

  ngOnInit(): void {
    this.checkViewPermission();
    this.getPaymentTerms();
      const customFilterName = "custom-equals";
      const notEquals = "not-equals";
      const dateAfter = "date-after";
      const dateBefore = "date-before";

      this.matchModeOptions = [
        { label: "Custom Equals", value: customFilterName },
        { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
        { label: "Contains", value: FilterMatchMode.CONTAINS }
      ];

      this.matchModeOptionsForDate = [
        { label: "Equals", value: customFilterName },
        { label: "Not Equals", value: notEquals },
        { label: "Greater Than", value: dateAfter },
        { label: "Less Than", value: dateBefore },
      ];

      this.matchModeOptionsForNumeric = [
        { label: "Custom Equals", value: customFilterName },
        { label: "Greater than or equal to", value: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
        { label: "Less than or equal to", value: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
      ];
      this.filterCondition=[
        {fieldName:"companyName",type:"basic"},
        {fieldName:"companyProfileId",type:"basic"},
        {fieldName:"companyType",type:"basic"},
        {fieldName:"adminName",type:"basic"},
        {fieldName:"adminEmail",type:"basic"},
        {fieldName:"paymentTerms",type:"basic"},
        {fieldName:"createdOn",type:"date"},
        {fieldName:"modifiedOn",type:"date"},
        {fieldName:"submittedOn",type:"date"},
        //{fieldName:"approvalStatus",type:"basic"},
        {fieldName:"approvalStatus",type:"dropdown"},

      ];
      this.matchModeOptionsForDropdown = [
        { label: "Equals", value: customFilterName },
        { label: "Not Equals", value: notEquals },
      ];
      this.getCompanyApprovalList();
      this.getCompanyApprovalStatus();
      this.getPaymentTerms();
      // this.companyService.getPaymentTerms(Payment_Terms.Net_45_Without_Fees).subscribe((data:any) =>{
      //   this.selectedPaymentTermsId.setValue(data);
      //   this.tempselectedPaymentTermsId = data;
      // });
      
  }
  checkSessionTimeout()
    {
  
      var isTokenAvailable = this.sharedService.isTokenAvailable();
      if(isTokenAvailable){
        var result = this.sharedService.checkSessionTimeout();
       // console.log('Session' + result);
         if(!result) {
           localStorage.removeItem('VMS');
           this._router.navigateByUrl('/login');
         }
      } 
     
    }
  checkViewPermission()
  {
    var result = this.sharedService.checkPermission("Admin_View");
    if(!result)
    this._router.navigateByUrl('/login');
  }
  getCompanyApprovalList()
  {
    //this.selectedPaymentTermsId.setValue(this.tempselectedPaymentTermsId);
    this.companyApprovalSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
       this.spinner.show(this.companyApprovalSearchSpinner);
    this.companyApprovalService.getAllCompanyApprovalList(this.companyApprovalSearchParam).subscribe((data: any) => {
      this.appliedFilters = [];
      this.companyApprovalList =data;
      this.isshowpaginator=this.companyApprovalList.length>0?true:false;
      console.log(data);
      this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.companyApprovalSearchSpinner);
     });
  }
  
  setColumnWidth(value) {
    if (this.showFilters == true && this.showSorting == true) {
      return value + 4 + 'rem'
    } else if (this.showFilters == true || this.showSorting == true) {
      return value + 2 + 'rem'
    }
    else {
      return value + 'rem'
    }
  }

  loadCompanyApprovalList(event:LazyLoadEvent)
  { 
    this.appliedFilters = [];
    this.loadEvent=event;
    if(event.first==0)
    {
      this.pageNo = 1;
    }
    else {
      this.pageNo=(event.first/event.rows)+1;
    }
    this.pageSize=event.rows;
    
    this.pageSize=event.rows;
    
    if((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize))
    {
      this.applyFilter();
      this.getCompanyApprovalList();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters=event.filters;
    if(this.filters["createdOn"]!= undefined)
    {
    if(this.filters["createdOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonCO = true;
    }
    else{
      this.showAddRuleButtonCO = false;
    }
    }
    if(this.filters["modifiedOn"]!= undefined)
    {
    if(this.filters["modifiedOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonMO = true;
    }
    else{
      this.showAddRuleButtonMO = false;
    }
    }
    if(this.filters["submittedOn"]!= undefined)
    {
    if(this.filters["submittedOn"][0].matchMode == "date-after")
    {
       this.showAddRuleButtonSO = true;
    }
    else{
      this.showAddRuleButtonSO = false;
    }
    }
    this.sortField=event.sortField;
    if(event.sortField === undefined || event.sortField === null)
    {
      this.sortField='createdOn';
    }
    if(event.sortOrder === 1)
    {
    this.sortOrder='desc';
    }
    if(event.sortOrder === -1)
    {
    this.sortOrder='asc';
    }
    if(this.oldSortField !==  this.sortField ||  this.oldSortOrder !== this.sortOrder)
    {
      this.applyFilter();
      this.getCompanyApprovalList()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }
   
  
  applyFilter()
  {
    if (Object.keys(this.filters).length > 1)
    {
      this.appliedFilters = [];
    for(let i=0;i<this.filterCondition.length;i++)
    {
      if(this.filterCondition[i].type == "checkbox")
      {
        if(this.filters[this.filterCondition[i].fieldName][0].value == true)
        {
          this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                    matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                    value:"true"}) 
        }
        else if (this.filters[this.filterCondition[i].fieldName][0].value == false){
          this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                    matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                    value:"false"}) 
        }
      }
      else if (this.filterCondition[i].type == "basic")
      {
        if(this.filters[this.filterCondition[i].fieldName][0].value !== null)
        this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                  matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                  value:this.filters[this.filterCondition[i].fieldName][0].value }) 
      }
      else if (this.filterCondition[i].type == "date")
      {
        for(let j=0; j<= this.filters[this.filterCondition[i].fieldName].length-1; j++)
        {
          if(this.filters[this.filterCondition[i].fieldName][j].value !== null)
          this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                    matchMode:this.filters[this.filterCondition[i].fieldName][j].matchMode,
                                    value: this.datepipe.transform(this.filters[this.filterCondition[i].fieldName][j].value,"MM-dd-yyyy") }) 
        }
      }
      else if (this.filterCondition[i].type == "numeric")
      {
        if(this.filters[this.filterCondition[i].fieldName][0].value !== null)
        this.appliedFilters.push({ field:this.filterCondition[i].fieldName,
                                  matchMode:this.filters[this.filterCondition[i].fieldName][0].matchMode,
                                  value:this.filters[this.filterCondition[i].fieldName][0].value }) 
      }
      /*else if (this.filterCondition[i].type == "dropdown") {
        if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
          if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
            this.appliedFilters.push({
              field: this.filterCondition[i].fieldName,
              matchMode: "custom-equals",
              value: this.filters[this.filterCondition[i].fieldName][0].value.lookupId
            })
          }
        }
      }*/

      else if (this.filterCondition[i].type == "dropdown") {
        if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
          if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
            if(this.filterCondition[i].fieldName != "All")
            {
              this.appliedFilters.push({
              field: this.filterCondition[i].fieldName,
              matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
              value: this.filters[this.filterCondition[i].fieldName][0].value.lookupId
            })}
          }
        }
      }
      
      
      // if(i==this.filterCondition.length-1 )
      // {
      //   this.startSearch = true; 
      // }
      
      
    }
    }
    

    //////////////////
      
    this.searchGlobalFilter = [];
      

    ///////////////////

    //if(this.startSearch == true)
    if(this.startSearch == true || this.startSearch == false)
    {
      this.companyApprovalSearchParam = 
       {
         pageNo:this.pageNo,
         pageSize:this.pageSize,
         sortField:this.sortField,
         appliedFilters:this.appliedFilters,
         searchGlobalFilter: this.searchGlobalFilter,
         sortOrder:this.sortOrder
       };
      this.spinner.show(this.companyApprovalSearchSpinner);
      this.companyApprovalService.getAllCompanyApprovalList(this.companyApprovalSearchParam).subscribe((data: any) => {
      //this.appliedFilters = [];
      this.companyApprovalList =data;
      this.isshowpaginator=this.companyApprovalList.length>0?true:false;
      console.log(this.companyApprovalList);
      this.totalRecords = data[0].totalCount;
      this.spinner.hide(this.companyApprovalSearchSpinner);
      });
    }
  }

  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
       this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
     this.appliedFilters = [];
     this.selectedApprovalStatus ="";
     this.selectedApprovalStatusId = undefined;

     this.selectedPaymentTerms ="";
     this.selectedPaymentTermsId = undefined;

    //  this.applyFilter();
    this.getCompanyApprovalList();
  }

  applyFilterNew(table: Table){
    this.filters=table.filters;
    this.applyFilter();
  }

  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }

  bindShowTopFilter() {
    this.showTopFilters = (this.showTopFilters ? false : true)
  }
  
  changeGlobalFilter(event) {
    
  }

  saveFilter()
  {

  }
  approveUser(userDetail:IUserDetails)
  {
    var id = userDetail.userProfileId;
    userDetail.isApproved = true;
    userDetail.isActive = true;
    this.companyApprovalService.approveCompany(id,userDetail).subscribe((data:any) =>{
      this.getCompanyApprovalList();
    })
  }
  
  approveCompany(adminUserProfile:number,companyId:number) {
    var loggedInUser = this.jwtService.getLoggedInUserProfileId();
    this.confirmationService.confirm({
        message: 'Are you sure that you want to approve this company?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.messageService.add({severity:'success', summary:'Confirmed', detail:'Company approved'});
            this.companyApprovalService.getUserProfileDetails(adminUserProfile).subscribe((data:IUserDetails) =>{
              console.log(data);
              var id = data.userProfileId;
              data.isApproved = true;
              data.isActive = true;
              this.companyApprovalService.approveCompany(id,data).subscribe((data:any) =>{
                this.registerService.updateCompanyForAdmin(data).subscribe((result:any) => {
                  this.companyApprovalService.updateVendorClientAssignment(companyId,loggedInUser).subscribe((res:any)=> {
                  
                  });
                });
                // if(this.paymentTermsId == null || this.paymentTermsId ==undefined)
                // {
                //   this.paymentTermsId = Payment_Terms.Net_45_Without_Fees;
                // }
                // this.companyApprovalService.updatePaymentTerms(companyId,this.paymentTermsId).subscribe((value:any)=> {
                //   this.paymentTermsId= undefined;
                // });
                this.getCompanyApprovalList();
              })
            })
        },
        reject: (type) => {
            switch(type) {
                case ConfirmEventType.REJECT:
                    this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
                break;
                case ConfirmEventType.CANCEL:
                    this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
                break;
            }
        }
    });
}

rejectCompany(companyProfileId:number) {
  this.notesFormControl.setValue('');
  this.confirmationService.confirm({
      message: 'Are you sure that you want to reject this company?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.displayModal = true;
        this.companyId =companyProfileId;
        this.userActionDescription = "Rejected";
        //this.companyService.GetCompanyNotes(this.companyId).subscribe((data:any)=>{
          //this.notesList = data;
        //});
          
      },
      reject: (type) => {
          switch(type) {
              case ConfirmEventType.REJECT:
                  this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
              break;
              case ConfirmEventType.CANCEL:
                  this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
              break;
          }
      }
  });
}

needInformation(event)
  {
   this.displayModal = true;
   this.companyId =this.selectedGridMenuItem.companyId;
   this.userActionDescription = "Need Information";
   this.notesFormControl.setValue('');
  }

  inReview(event)
  {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to change In Review?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        var loggedInUser = this.jwtService.getLoggedInUserProfileId();
        this.companyId =this.selectedGridMenuItem.companyId;
        this.companyApprovalService.inReviewCompany(this.companyId,loggedInUser).subscribe((data:any) =>{
          this.getCompanyApprovalList();
        });
          
      },
      reject: (type) => {
          switch(type) {
              case ConfirmEventType.REJECT:
                  this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
              break;
              case ConfirmEventType.CANCEL:
                  this.messageService.add({severity:'warn', summary:'Cancelled', detail:'You have cancelled'});
              break;
          }
      }
  });
  
  }

  formatAnswerText = (txt) => {
    return txt.length > 10 ? `${txt.substring(0, 100)}...` : txt;
  }
  notesHistory(event)
  {
    console.log(this.selectedGridMenuItem.companyId);
    this.displayNotesHistoryModal = true;
    this.companyId =this.selectedGridMenuItem.companyId;
     this.companyService.GetCompanyNotes(this.companyId).subscribe((data:any)=>{
       console.log(data);
       for(let i=0;i<data.length;i++)
       {
        data[i].description = data[i].description.replace(/<[^>]+>/g, '');
       }
          this.notesList = data;
        });
        console.log( this.notesList);
  }
  
updateCompanyNotes() {
  var loggedInUser = this.jwtService.getLoggedInUserProfileId();
 // this.notes = this.notesFormControl.value;
  const companyNotes:ICompanyNotes={
    description: this.notesFormControl.value,
    companyId: this.companyId,
    action:this.userActionDescription,
    createdBy: this.jwtService.getLoggedInUserProfileId(),
    createdOn: new Date(),
    modifiedBy: this.jwtService.getLoggedInUserProfileId(),
    modifiedOn: new Date(),
    NotesId: 0
  }
  if( this.userActionDescription == "Rejected")
  {
  //this.notes ='';
  this.notesFormControl.setValue('');
  this.messageService.add({severity:'success', summary:'Confirmed', detail:'Company rejected'});
  this.companyApprovalService.rejectCompany(this.companyId,loggedInUser).subscribe((data:any) =>{
    setTimeout(() => {
      this.getCompanyApprovalList();
              this.companyService.updateCompanyNotes(companyNotes).subscribe((data:any) =>{
               
              });
  }, 3000);
            
   })
}
else if( this.userActionDescription == "Need Information")
 {
  //this.notes ='';
  this.notesFormControl.setValue('');
  this.companyApprovalService.needInformation(this.companyId,loggedInUser).subscribe((data:any) =>{
    setTimeout(() => {
      this.getCompanyApprovalList();
              this.companyService.updateCompanyNotes(companyNotes).subscribe((data:any) =>{
                
              });
  }, 3000);
})
 
 }
}

viewCompanyProfile(adminUserProfile: number) {
  this._router.navigate(['/admin/company-approval-view', { adminUserProfile: adminUserProfile }]);
}

exportCompanyApproval() {
  this.applyFilter();
  this.companyApprovalSearchParam = 
   {
    pageNo:this.pageNo,
    pageSize:this.pageSize,
    sortField:this.sortField,
    appliedFilters:this.appliedFilters,
    sortOrder:this.sortOrder
   };
   this.companyService.ExportCompanyApprovalResult(this.companyApprovalSearchParam).subscribe(res => {
   var blob = new Blob([res.body], { type: res.body.type });
   const file = new File([blob],"CompanyApproval.xlsx", { type: res.body.type });
   fs.saveAs(file);
   });
}

notesDescription(notesId:number)
{
  this.displayNotesDescriptionModal = true;
  this.companyService.getNotesDescription(notesId).subscribe((data:any) =>{
    this.loadNotesDescription(data.description);
  })
}

@ViewChild('notesDescriptionContainer') notesDescriptionContainer: ElementRef;

loadNotesDescription(data) {
    this.notesDescriptionContainer.nativeElement.innerHTML = data;
  }

  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event){
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName){
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if(tempColumn.length == 1){
      return true;
    }
    return false;
  }
  cancelNotes()
  {
    //this.notes='';
    this.notesFormControl.setValue('');
  }

  getPaymentTerms() {
    this.categoryName = 'Payment Terms';
      this.sharedService.getLookupMasterByCategoryId(LookupCategory.PaymentTerms).subscribe((data: any) => {
      this.paymentTermsList = data;
      this.arrPaymentTerms = this.paymentTermsList;
      this.arrPaymentTerms=this.arrPaymentTerms.filter(x=>x.description == 'Net 45 without fees' || x.description == 'Net 30 with 2% fees')
      this.arrPaymentTerms.push({categoryId:0,createdBy:0,createdByUser:null,createdOn: null,description:"All",isActive: true,
      lookupCategory: null,
      lookupId: 0,
      lookupOrder: 0,
      modifiedBy: 0,
      modifiedByUser: null,
      modifiedOn: null});
      this.arrPaymentTerms.sort((a, b) => (a.description < b.description) ? -1 : 1);
      this.paymentTermsList = this.arrPaymentTerms;
      console.log(this.arrPaymentTerms);
    });
  }
  getPaymentTermsOnChange(event) {
    //this.paymentTermsId = event.value.lookupOrder;

    this.selectedPaymentTerms = event.value.description;
    if(event.value.description!="All")
    {
      //this.paymentTermsId = event.value.lookupId;
      this.paymentTermsId = event.value.lookupOrder;
      this.companyService.getPaymentTerms(event.value.lookupOrder).subscribe((data:any) =>{
      this.selectedPaymentTermsId = data;
      });
    }
  }

  clearPaymentTerms()
 {
  this.selectedPaymentTerms ="";
  this.selectedPaymentTermsId = undefined;
 }

  getCompanyApprovalStatus() {
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.CompanyApprovalStatus).subscribe((data: any) => {
    this.companyApprovalStatus = data;
    this.companyApprovalStatus = data.filter(item => item.description !== 'Approved' && item.description !== 'Insufficient Information');
    this.arrCompanyApprovalStatus = this.companyApprovalStatus;
    this.arrCompanyApprovalStatus.push({categoryId:0,createdBy:0,createdByUser:null,createdOn: null,description:"All",isActive: true,
    lookupCategory: null,
    lookupId: 0,
    lookupOrder: 0,
    modifiedBy: 0,
    modifiedByUser: null,
    modifiedOn: null});
    this.arrCompanyApprovalStatus.sort((a, b) => (a.description < b.description) ? -1 : 1);
    this.companyApprovalStatus = this.arrCompanyApprovalStatus;
  });
 }

 getApprovalStatusOnChange(event)
 {
  /*this.approvalStatusId = event.value.lookupId;
  this.selectedApprovalStatus = event.value.description;
  this.companyService.getCompanyApprovalStatus(event.value.lookupId).subscribe((data:any) =>{
    this.selectedApprovalStatusId = data;
  });*/

  
  this.selectedApprovalStatus = event.value.description;
  if(event.value.description!="All")
  {
     this.approvalStatusId = event.value.lookupId;
     this.companyService.getCompanyApprovalStatus(event.value.lookupId).subscribe((data:any) =>{
     this.selectedApprovalStatusId = data;
     });
  }
 }

 clearApprovalStatus()
 {
  this.selectedApprovalStatus ="";
  this.selectedApprovalStatusId = undefined;
 }

 editorMaxLength(maxlength): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    var regex = /(<([^>]+)>)/ig;
    var value = control.value;
    if (value == null) {
      return null;
    }
    var result = value.replace(regex, "");
    if (result.length > maxlength) {
      return { 'maxlengthError': true };
    } else {
      return null;
    }
  }
}

}
